
import { Poll } from '@/types/poll';
import { usePollSave } from './usePollSave';
import { usePollStatus } from './usePollStatus';
import { usePollDelete } from './usePollDelete';
import { usePollCardLink } from './usePollCardLink';

export const usePollActions = (
  polls: Poll[], 
  setPolls: React.Dispatch<React.SetStateAction<Poll[]>>, 
  setDialogOpen: React.Dispatch<React.SetStateAction<boolean>>
) => {
  const { handleSavePoll } = usePollSave(polls, setPolls, setDialogOpen);
  const { 
    handleActivatePoll, 
    handleClosePoll, 
    handleReopenPoll 
  } = usePollStatus(polls, setPolls);
  const { handleDeletePoll } = usePollDelete(polls, setPolls);
  const { linkPollToCard } = usePollCardLink(polls, setPolls);

  return {
    handleSavePoll,
    handleDeletePoll,
    handleActivatePoll,
    handleClosePoll,
    handleReopenPoll,
    linkPollToCard
  };
};
